import { StyledFilterStrip } from "./style";

interface FilterStripProps {
  children: React.ReactNode;
  width?: string;
}
function FilterStrip(props: FilterStripProps) {
  return (
    <StyledFilterStrip
      css={{ "--gridW": props.width }}
      layout={'l1'}
    >
      {props.children}
    </StyledFilterStrip>
  );
}

export { FilterStrip };
